/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Sushma Vishwakarma',
        title: 'Data Analyst',
        text: "I am thoroughly impressed with Swapnali's professionalism and commitment to delivering exceptional work.",
        image: girl2
    },
    {
        id: 2,
        name: 'Sandeep Soni',
        title: 'Project Manager',
        text: "Swapnali is extremely talented, reliable, and always willing to go the extra mile to ensure that the project is a success. I would not hesitate to recommend swapnali as a top-notch frontend developer.",
        image: boy2
        
    },
    {
        id: 3,
        name: 'Karishma Patil',
        title: 'Frontend Developer',
        text: "Swapnali is an excellent communicator and collaborator, and her dedication to delivering exceptional work is evident in everything she does :)",
        image: girl1
    },
    {
        id: 4,
        name: 'Ashitosh Desai',
        title: 'Web Developer',
        text: "I highly recommend Swapnali to anyone looking for a talented frontend developer who can bring their vision to life and exceed their expectations.",
        image: boy1
    },
    {
        id: 5,
        name: 'Neha Kaushik',
        title: 'UI/UX Developer',
        text: 'I had the pleasure of working with Swapnali on a web development project and was thoroughly impressed by her technical expertise and ability to turn complex designs into fully functional web pages.',
        image: girl3
    },
    {
        id: 6,
        name: 'Rohit Pednekar',
        title: 'Reactjs Developer',
        text: "Swapnali's ability to translate complex designs into functional web pages is impressive!",
        image: boy3
    }
]

